import AlertModal from "components/v2/Modals/AlertModal/AlertModal";
import React from "react";
import { TrackerAlertModalsProps } from "components/v2/Modals/TrackerAlertModals/types/TrackerAlertModalsProps";
import { useBrandsConfig } from "utils/v2/BrandsConfig/BrandsConfigContext";
import { useNavigate } from "react-router";

const TrackerAlertModals: React.FC<TrackerAlertModalsProps> = ({
  tracker,
  isPaymentModalOpen,
  closePaymentModal,
  trackers,
  onActionOne,
}) => {
  const { persianTitle } = useBrandsConfig();
  const navigate = useNavigate();
  let trackerTitles;
  if (trackers) {
    trackerTitles =
      trackers.length > 1
        ? trackers?.map((tracker) => tracker.title).join(" و ")
        : trackers[0]?.title;
  }

  const handleActionOne = () => {
    if (onActionOne) {
      onActionOne();
    } else {
      navigate("/plans");
    }
  };

  return (
    <>
      <AlertModal
        content={
          trackers
            ? `مدت اشتراک استفاده از اپلیکیشن ${persianTitle} برای ردیاب ${
                trackerTitles ? trackerTitles : "شما"
              } به پایان رسیده است برای انتخاب پلن و تمدید تائید کنید.`
            : `مدت اشتراک استفاده از اپلیکیشن ${persianTitle} برای ردیاب ${
                tracker?.title ? tracker?.title : "شما"
              } به پایان رسیده است برای انتخاب پلن و تمدید تائید کنید.`
        }
        type="info"
        onClose={closePaymentModal}
        isOpen={isPaymentModalOpen}
        actionOneButtonText="پلن ها"
        actionOne={handleActionOne}
        actionTwoButtonText="متوجه شدم"
        actionTwo={closePaymentModal}
        twoOptionsAlert
        hasIcon
        hasButton
      />
    </>
  );
};
export default TrackerAlertModals;
